import React from 'react'
import Comingsoon from '../components/organisms/Comingsoon'

function Playgame() {
    return (
        <>
            <Comingsoon />
        </>
    )
}

export default Playgame
